import Banner from "elements/Banner";
import ButtonSymphony from "elements/ButtonSymphony";
import CardSymphony from "elements/CardSymphony";
import TagSymphony, { Tag } from "elements/TagSymphony";
import useCampaignBuilder from "Hooks/useCampaignBuilder";
import useScreen from "Hooks/useScreen";
import Sty from "modules/Sty";
import { TargetingAudienceGroup } from "modules/Types";
import { clsx, makeKey } from "modules/Utils";
import { CSSProperties, useState } from "react";

interface TargetingCampaignView_PREVIEWProps {
    className?: string;
    platform: 'tiktok' | 'facebook'
}

const TargetingCampaignView_PREVIEW = ({
    className,
    platform = 'tiktok'
}: TargetingCampaignView_PREVIEWProps) => {
    const { mStyle } = useScreen();
    const {
        selectedAudienceGroups,
        setSelectedAudienceGroups,
        removeInterestFromAudienceGroup: removeInterestFromAudienceGroup,
        addInterestToAudienceGroup: addToAudienceGroup,
        removeAudienceGroup
    } = useCampaignBuilder()

    return (
        <CardSymphony
            className={clsx('targetingCampaignView_PREVIEWComponent', className)}
            style={{
                ...mStyle(sty, 'targetingCampaignView_PREVIEWComponent'),
                marginTop: 48,
                borderRadius: 8
            }}
            title="Your Targeted Audiences"
            isNoPadding
            size="small"
        >
            {selectedAudienceGroups.map((audience: TargetingAudienceGroup) => {
                return (
                    <Banner
                        color="maestro"
                        style={{
                            border: Sty.border
                        }}
                        className="audiencePreviewItem" key={`audience-${audience.id}`}>
                        <div className="audiencePreviewHeader" style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}>
                            <div className="audiencePreviewTitle" style={sty.audiencePreviewTitle}>
                                {audience.title}
                            </div>
                            <ButtonSymphony
                                style={{
                                    paddingTop: 0
                                }}
                                className="audiencePreviewRemoveButton"
                                variant="text"
                                size="small"
                                onClick={() => removeAudienceGroup(audience.id)}

                            >Remove Targeting</ButtonSymphony>
                        </div>
                        <div className="audiencePreviewTags" style={sty.audiencePreviewTags}>
                            {audience.tags.map((tag: Tag, index: number) => {
                                return (
                                    <TagSymphony
                                        key={makeKey('audience-preview-tag', tag.id, index)}
                                        className="audiencePreviewTag"
                                        color="grey"
                                        tag={tag}
                                        onRemove={() => removeInterestFromAudienceGroup(audience.id, Number(tag.id))}
                                    />
                                )
                            })}
                        </div>
                    </Banner>
                )
            })}
        </CardSymphony>
    )
}

const sty: Record<string, CSSProperties> = {
    targetingCampaignView_PREVIEWComponent: {
        display: 'flex',
        flexDirection: 'column',
        padding: 16,
        gap: 16,
    },
    targetingCampaignView_PREVIEWComponent_mobile: {
        padding: 0,
    },
    audiencePreviewTags: {
        display: 'flex',
        flexDirection: 'row',
        gap: 8,
        flexWrap: 'wrap',
    },
    audiencePreviewTitle: {
        ...Sty.text16grey,
        marginBottom: 8,
    }
}

export default TargetingCampaignView_PREVIEW;